import loadable from '@loadable/component'

export default [
  {
    path: '/secretAdd/protect',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SecretAdd-protect" */ '~/pages/SecretAdd/pages/protect'
        )
    ),
  },
  {
    path: '/secretAdd/password',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SecretAdd-password" */ '~/pages/SecretAdd/pages/password'
        )
    ),
  },
  {
    path: '/secretAdd/set',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SecretAdd-set" */ '~/pages/SecretAdd/pages/set'
        )
    ),
  },
  {
    path: '/secretAdd/success',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SecretAdd-success" */ '~/pages/SecretAdd/pages/success'
        )
    ),
  },
]
